import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Switch, Select, Form, Input } from 'antd';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import { LeftCircleOutlined } from '@ant-design/icons';
import InputMask from 'react-input-mask';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchRolesByType from '../../hooks/fetchRolesByType';
import useFetchRoles from '../../hooks/fetchRoles';
console.log(app);


const Useradd = () => {
  const { t } = useTranslation(['common']);
  const [phone, setPhone] = useState();
  const [addUserResp,setAddUserResp] = useState({});
  const [pwd,setpwd]=useState('');
  const [confirmPwd,setconfirmPwd]=useState('');
  const [show, setShow] = useState(false); 
   const [uploadObj, setUploadObj] = useState({});
  let navigate = useNavigate();
  const token=getTokenfromUserObj();
  let user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  const roleResp = user.userType==="A"?useFetchRoles():useFetchRolesByType();
  const roles = roleResp.response ? roleResp.response.data : [];
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/user/signup`, uploadObj,{headers:{auth:token}});
      if(res.data.statusCode === 200){
        setAddUserResp(res.data)
        setTimeout(()=>{
          if(user.userType==="A")navigate('/user/getusers', { replace: true });
          else if(user.userType==="O")navigate('/orguser/view', { replace: true });
          // navigate('/user/getusers')
        
        },1000)
      }
    } catch (err) {
      console.log(err);
    }
  };
  function goBack() {
    if(user.userType==="A")navigate('/user/getusers', { replace: true });
    else if(user.userType==="O")navigate('/orguser/view', { replace: true });
   }
   window.addEventListener('popstate', goBack);
  const handleChange = (event) => {
    setPhone(event.target.value);
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    if(pwd!==confirmPwd){
      console.log(pwd,confirmPwd);
      message.error("Passwords do not match")
      return; 
    }
    setUploadObj({
      name: values.name ? values.name : null,
      email: values.email ? values.email : null,
      Password: values.password ? values.password : null,
      phone: phone ? phone : '',
      roleId: values.roleId ? values.roleId : null,
      organizationId:  user.userType==="A" && values.organizationId ? values.organizationId : user.organizationId,
      isActive: values.isActive === true ? 1 : 0,
      userType: 'O',
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
 const submitData=()=>{
    console.log('calling')  
    if (Object.keys(uploadObj).length > 0) {
    if(phone.split("_")[0].length<14){
      setShow(false);
      message.error('Invalid mobile number')
      return;
    }
    else uploadData(uploadObj);
  }
}
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);



  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                if(user.userType==="A")navigate('/user/getusers', { replace: true });
                else if(user.userType==="O")navigate('/orguser/view', { replace: true });
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add User')} </h2>
          </div>{' '}
        </div>
        <div class='col mb-5 w-50 mt-4'>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['email']: null,
                ['password']: null,
                ['isActive']: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
                            {/* Select box for Role */}

           {user.userType==="A"?  <Form.Item
                colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization'
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item>   :" "}  
             
              <Form.Item
                label='Name'
                name='name'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Name',
                  },
                ]}
              >
                <Input placeholder='Enter Name' />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Email'
                autoComplete="off"
                name='email'
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'Enter email',
                  },
                ]}
              >
                <Input placeholder='Enter Email' autoComplete="new-email" defaultValue={" "} />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Password'
                autoComplete="off"
                name='password'
                rules={[
                  {
                    required: true,
                    message: 'Enter Password',
                  },
                  {
                    pattern: /[a-z]/,
                    message: 'Password must contain at least one lowercase letter',
                  },
                  {
                    pattern: /[A-Z]/,
                    message: 'Password must contain at least one uppercase letter',
                  },
                  {
                    pattern: /\d/,
                    message: 'Password must contain at least one number',
                  },
                ]}
              >
                <Input.Password onChange={(e)=>setpwd(e.target.value)} placeholder='Enter Password' autoComplete="new-password" defaultValue={" "} />
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Confirm Password'
                name='confirmPassword'
                rules={[
                  {
                    required: true,
                    message: 'Re-enter Password!',
                  },
                  {
                    pattern: /[a-z]/,
                    message: 'Password must contain at least one lowercase letter',
                  },
                  {
                    pattern: /[A-Z]/,
                    message: 'Password must contain at least one uppercase letter',
                  },
                  {
                    pattern: /\d/,
                    message: 'Password must contain at least one number',
                  },
                ]}
              >
                <Input.Password  placeholder='Re-enter Password' onChange={(e)=>setconfirmPwd(e.target.value)} />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Mobile'
                name='phone'
                rules={[
                  {
                    required: true,
                    minLength:10,
                    message: 'Enter Phone',
                  },
                ]}
              >
              
                    <InputMask mask='(999) 999-9999'  onChange={handleChange}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Phone Number' />}
                  {/* <Input /> */}
                </InputMask>
                {/* <Input placeholder='Input Contact' /> */}
              </Form.Item>
              <Form.Item
                label='Role'
                colon={false}
                name='roleId'
                rules={[
                  {
                    required: true,
                    message: 'Select Role',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 180,
                  }}
                  placeholder='Select Role'
                >
                  {roles.map((role) => {
                    return (
                      <Option key={role.roleId} value={role.roleId}>
                        {role.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
                
              {/* Select box for Organization */}

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
        {addUserResp.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>:addUserResp.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to add user?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}

                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Save
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Useradd;
